// Deterministic display metadata for catalog cards (all content is Free on ReelVault).
const MATURITY_BY_KEYWORD = [
  { rating: "TV-MA", keys: ["horror", "thriller", "crime", "slasher", "gore", "noir"] },
  { rating: "TV-14", keys: ["action", "war", "sci-fi", "adventure", "drama"] },
  { rating: "TV-PG", keys: ["documentary", "news", "music", "music video", "concert", "classic"] },
  { rating: "PG-13", keys: ["comedy", "romance", "family"] },
];

export const getMaturity = (video) => {
  const kws = (video?.keywords || []).map((k) => String(k).toLowerCase());
  for (const { rating, keys } of MATURITY_BY_KEYWORD) {
    if (keys.some((k) => kws.includes(k))) return rating;
  }
  const opts = ["PG-13", "TV-14", "TV-PG"];
  const id = video?.video_id || "x";
  return opts[id.charCodeAt(id.length - 1) % opts.length];
};

export const getGenreLabel = (video) => {
  const kw = (video?.keywords || []).find((k) => !["trailer", "hollywood", "music video"].includes(String(k).toLowerCase()));
  if (!kw) return "Feature";
  return String(kw).replace(/\b\w/g, (c) => c.toUpperCase());
};

export const isMusic = (video) => {
  const kws = (video?.keywords || []).map((k) => String(k).toLowerCase());
  return kws.some((k) => k.includes("music") || k === "visualizer");
};

export const isPodcast = (video) =>
  (video?.keywords || []).map((k) => String(k).toLowerCase()).includes("podcast");

export const relativeAdded = (createdAt) => {
  if (!createdAt) return null;
  const t = new Date(createdAt).getTime();
  if (Number.isNaN(t)) return null;
  const diff = Date.now() - t;
  const days = Math.floor(diff / 86400000);
  if (days <= 0) {
    const hrs = Math.floor(diff / 3600000);
    return hrs <= 1 ? "Added just now" : `Added ${hrs}h ago`;
  }
  if (days === 1) return "Added 1 day ago";
  return `Added ${days} days ago`;
};

export const isJustAdded = (video) => {
  if (!video?.created_at) return false;
  const t = new Date(video.created_at).getTime();
  return !Number.isNaN(t) && t > Date.now() - 24 * 60 * 60 * 1000;
};
